const BrandMonitor = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <main className="container py-6 flex-1">
        <h1 className="text-4xl font-bold mb-8 text-center">Brand Monitor</h1>
        <p className="text-center text-muted-foreground">
          This feature is coming soon.
        </p>
      </main>
    </div>
  );
};

export default BrandMonitor;